var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlagFalklandIslands(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1354_15523)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32 16.0117C32 24.8482 24.8365 32.0117 16 32.0117C7.1635 32.0117 0 24.8482 0 16.0117C0 16.0155 16 0.0134688 16 0.0117188C24.8365 0.0117188 32 7.17522 32 16.0117Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9572 16.0118H16C16 15.9974 16 15.9834 16 15.969C15.9857 15.9833 15.9715 15.9976 15.9572 16.0118Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 8.35953C16 5.54422 16 3.69953 16 0.0117188H15.9973C7.162 0.0132188 0 7.17603 0 16.0117H8.34781V11.311L13.0486 16.0117H15.9572L16.0001 15.9689C16.0001 14.891 16.0001 13.9292 16.0001 13.0603L11.2992 8.35953H16Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.09469 2.09863C5.59226 3.52357 3.51188 5.60395 2.08694 8.10638V16.0117H6.26088V6.2727V6.27257H16C16 4.95613 16 3.70201 16 2.09863H8.09469Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 14.0442L10.3154 8.35962H8.34789V8.35974L15.9999 16.0117H16C16 16.0117 16 14.6551 16 14.0442Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.7391 18.7944V19.4901H20.1739V18.7944H18.0869V21.577H19.4783V22.2727H26.4348V21.577H27.8261V18.7944H25.7391Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.0869 8.35962V16.0118C18.0869 19.7392 22.9565 20.8814 22.9565 20.8814C22.9565 20.8814 27.8261 19.7392 27.8261 16.0118V8.35962H18.0869Z",
    fill: "#338AF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.9563 14.0674C21.7389 14.0674 21.7389 15.1804 20.5216 15.1804C19.3043 15.1804 19.3043 14.0674 18.087 14.0674V16.0152C19.3043 16.0152 19.3043 17.1283 20.5216 17.1283C21.7389 17.1283 21.7389 16.0152 22.9563 16.0152C24.1737 16.0152 24.1737 17.1283 25.3912 17.1283C26.6087 17.1283 26.6086 16.0152 27.8261 16.0152V14.0674C26.6087 14.0674 26.6087 15.1804 25.3912 15.1804C24.1737 15.1804 24.1737 14.0674 22.9563 14.0674Z",
    fill: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.9563 10.1682C21.7389 10.1682 21.7389 11.2813 20.5216 11.2813C19.3043 11.2813 19.3043 10.1682 18.087 10.1682V12.116C19.3043 12.116 19.3043 13.2291 20.5216 13.2291C21.7389 13.2291 21.7389 12.116 22.9563 12.116C24.1737 12.116 24.1737 13.2291 25.3912 13.2291C26.6087 13.2291 26.6086 12.116 27.8261 12.116V10.1682C26.6087 10.1682 26.6087 11.2813 25.3912 11.2813C24.1737 11.2813 24.1737 10.1682 22.9563 10.1682Z",
    fill: "#F3F3F3"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1354_15523"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0 0.0117188)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagFalklandIslands);
export default __webpack_public_path__ + "static/media/flag_falkland_islands.e60a87ea1d132318b433b8b61edfba27.svg";
export { ForwardRef as ReactComponent };